import { api } from '../api';
import { showBadToast, showGoodToast } from '../../errors/toast';
import logMessage from '../../errors/foutlog';
import {
    ProdRun,
    Bak,
    BakIngredient,
    BakInfo,
    BakInfoHist,
    BakDefaults,
    CheeseMarks,
    AlternativeCheese,
    ScaleInfo,
    EquipmentStepsInfo,
    EquipmentStepInfo
} from '../../../models/BakInfo';
import { ActiviteitenLog } from '../../../models/ActiviteitenLog';
import { InpekelItem } from '../../../models/BakInfo_helper';
import { Product } from '../../../models/Product';
import { AttachmentInfo } from '../../../models/PlusProduction';
import { BatchAssessment, QualityDeviation } from '@/models/Quality';
import Store from '@/store';
const actions = {
    async loadBatch(context, data) {
        let item = null;
        try {
            await api.fetchBatch(data.data).then((response) => {
                item = new Bak(response.data);
            });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertSelectedBatch', item);
        return item;
    },
    async loadBatchActivityLog(context, data) {
        let tempList = [];
        try {
            await api.fetchBatchActivityLog(data.data).then((response) => {
                tempList = response.data.map((x) => new ActiviteitenLog(x));
            });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_activities', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertSelectedBatchActivities', tempList);
        return tempList;
    },

    async loadBatchQualityPrediction(context, data) {
        let item = null;
        try {
            const data1 = await api.fetchBatchQualityPrediction(data.data);
            item = data1 ? new BatchAssessment(data1.data) : null;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
        return item;
    },
    // int batchID
    async printBatchReport(context, data) {
        let file = [];
        try {
            await api.fetchBatchReportInfo(data.data).then((response) => {
                file = response.data;
            });
        } catch (error) {
            file = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_bijlagen', { ns: 'common' })
                }),
                error
            );
        }
        return file;
    },
    async moveBatchToEnd(context, data) {
        try {
            await api.moveBatchToEnd(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
    },
    async deleteBatch(context, data) {
        try {
            await api.deleteBatch(data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
    },
    async destroyBatch(context, data) {
        try {
            await api.destroyBatch(data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
    },
    async updateBatch(context, data) {
        try {
            let item = null;
            await api.updateBatch(data.data).then((response) => {
                item = new Bak(response.data);
            });
            context.commit('insertSelectedBatch', item);
            return item;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data
                        .func('prod_bak', { ns: 'production' })
                        .toLowerCase()
                }),
                error
            );
        }
    },
    async loadBatchInfo(context, data) {
        let tempList = [];
        try {
            await api.fetchBatchInfo(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new BakInfo(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_bakinfo', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertBatchInfoLijst', tempList);
        return tempList;
    },
    async loadBatchInfoOverPeriod(context, data) {
        let tempList = [];
        try {
            await api.fetchBatchInfoOverPeriod(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new BakInfoHist(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_bakinfo', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertBatchInfoHistLijst', tempList);
        return tempList;
    },
    async addBatches(context, data) {
        let tempList = [];
        try {
            await api.addBatches(data.data).then((response) => {
                tempList = response.data; //.map((x) => ({
                //batchID: x.id
                //}));
            });
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('prod_bakken', { ns: 'production' })
                }) +
                    ' ' +
                    data.data.batches
            );
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_bakken', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async assignSalesOrder(context, data) {
        try {
            await api.assignSalesOrder(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_assignment', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_assignment', { ns: 'common' })
                }),
                error
            );
        }
    },

    async addStarterSubType(context, data) {
        try {
            await api.setStarterSubType(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('prod_zuurseltype', { ns: 'production' })
                })
            );
            return true;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_zuurseltype', { ns: 'production' })
                }),
                error
            );
            return false;
        }
    },
    async addBatchingredients(context, data) {
        let item = null;
        try {
            const response = await api.addBatchIngredients(data.data);
            item = response.data;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data
                        .func('prod_ingredient', { ns: 'production' })
                        .toLowerCase()
                }),
                error
            );
        }
        return item;
    },
    async loadBatchIngredients(context, data) {
        let tempList = [];
        try {
            await api.fetchBatchIngredients(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new BakIngredient(x));
            });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_ingredienten', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertBatchIngredientenLijst', tempList);
        return tempList;
    },
    async loadBatchIngredient(context, data) {
        let item = null;
        try {
            await api.fetchBatchIngredient(data.data).then((response) => {
                item = new BakIngredient(response.data);
            });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_ingredient', { ns: 'production' })
                }),
                error
            );
        }
        context.commit('insertSelectedBatchIngredient', item);
        return item;
    },
    async deleteBatchIngredient(context, data) {
        try {
            await api.deleteBatchIngredient(data.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_ingredient', { ns: 'production' })
                }),
                error
            );
        }
    },

    async loadBatchInbrineAmounts(context, data) {
        let tempList = [];
        try {
            const response = await api.fetchBatchInbrineAmounts(data.data);
            const bakId = response.data.batchID;
            tempList = response.data.amounts.map((x) => {
                const res = new InpekelItem(x);
                res.bakId = bakId;
                return res;
            });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_inpekelinfo', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertInpekelBatch', tempList);
        return tempList;
    },
    async loadBatchAlternativeCheeseTypes(context, data) {
        let tempList = [];
        try {
            await api
                .fetchAlternativeCheeseTypes(data.data)
                .then((response) => {
                    tempList = response.data.map(
                        (x) => new AlternativeCheese(x)
                    );
                });
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_alternatieven', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertAlternativeCheese', tempList);
        return tempList;
    },
    async loadBatchDefaults(context, data) {
        let item = null;
        try {
            const response = await api.fetchBatchDefaults(data.data);
            item = new BakDefaults(response.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_bakdefault', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertBatchdefaults', item);
        return item;
    },
    async loadMilkusagefactor(context, data) {
        let getal = null;
        try {
            const response = await api.fetchMilkusagefactoForBatch(data.data);
            getal = response.data;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_melkfactor', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertMilkusagefactor', getal);
        return getal;
    },
    async loadMilkInfo(context, data) {
        let tempList = [];
        try {
            const response = await api.fetchMilkInfoForDay(data.data);
            tempList = response.data.map((x) => new Product(x));
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_melktype', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertMilkLijst', tempList);
        return tempList;
    },
    async loadStarterInfo(context, data) {
        let tempList = [];
        try {
            const response = await api.fetchStarterSubtypesForDay(data.data);
            tempList = response.data;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_zuursel', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        return tempList;
    },
    async updateBatchInBrine(context, data) {
        try {
            await api.updateBatchInBrine(data.data);
            return true;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data
                        .func('prod_inpekel', { ns: 'production' })
                        .toLowerCase()
                }),
                error
            );
        }
    },
    async deleteEquipmentStepsforBatch(context, data) {
        try {
            await api.deleteEquipmentStepsFromBatch(data.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_equipsteps', { ns: 'production' })
                }),
                error
            );
        }
    },
    async loadEquipmentSteps(context, data) {
        let tempList = [];
        try {
            const response = await api.fetchEquipmentSteps(data.data);
            const o = new EquipmentStepsInfo(response.data);
            tempList = o.stappen ?? [];
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_equipsteps', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertEquipmentSteps', tempList);
        return tempList;
    },
    async loadPreviousEquipmentSteps(context, data) {
        let tempList = [];
        try {
            const response = await api.fetchPreviousEquipmentSteps(data.data);
            const o = new EquipmentStepsInfo(response.data);
            tempList = o.stappen ?? [];
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_equipsteps', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        return tempList;
    },
    async storeEquipmentSteps(context, data) {
        let tempList = [];
        try {
            const response = await api.storeEquipmentSteps(data.data);
            const o = new EquipmentStepsInfo(response.data);
            tempList = o.stappen ?? [];
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_equipsteps', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async updateBatchMarks(context, data) {
        try {
            await api.setCheeseMarks(data.data);
            return true;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_marks', { ns: 'common' }).toLowerCase()
                }),
                error
            );
            return false;
        }
    },
    async loadCheeseMarksForBatch(context, data) {
        let item = null;
        try {
            await api.fetchCheeseMarksForBatch(data.data).then((response) => {
                item = new CheeseMarks(response.data);
            });
            context.commit('insertMarksForBatch', item);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_marks', { ns: 'common' })
                }),
                error
            );
        }
        return item;
    },
    async repairCheeseMarksForBatch(context, data) {
        let item = null;
        try {
            item = await api.repairCheeseMarks(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_marks', { ns: 'common' }).toLowerCase()
                })
            );
            return true;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_marks', { ns: 'common' }).toLowerCase()
                }),
                error
            );
        }
        return item;
    },
    async loadMarkType(context, data) {
        let item = null;
        try {
            item = await api.fetchCheeseMarkType(data.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_marks', { ns: 'common' })
                }),
                error
            );
        }
        return item;
    },
    async saveBakTimer(context, data) {
        if (data.data) {
            const tempList = context.state.timerList;
            const index = tempList.findIndex((x) => x.bakID == data.bakID);
            if (index < 0) {
                tempList.push(data.data);
            } else {
                tempList[index] = data.data;
            }
            context.commit('insertTimerLijst', tempList);
        }
    },
    async loadProdrun(context, data) {
        let item = null;
        try {
            const response = await api.fetchProdRun(data.data);
            item = new ProdRun(response.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_production', { ns: 'common' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertProdrun', item);
        return item;
    },
    async setDataPointStatus(context, data) {
        let item = null;
        try {
            const response = await api.setDataPointStatus(data.data);
            item = response.data;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_status', { ns: 'common' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        return item;
    },
    async loadInbrineDataAccepted(context, data) {
        let tempList = [];
        try {
            await api.fetchInbrineDataAccepted(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new ScaleInfo(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_scaledata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async loadInbrineDataIgnored(context, data) {
        let tempList = [];
        try {
            await api.fetchInbrineDataIgnored(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new ScaleInfo(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_scaledata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async loadInbrineDataToProcess(context, data) {
        let tempList = [];
        try {
            await api.fetchInbrineDataToProcess(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new ScaleInfo(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_scaledata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async loadLinkedOstData(context, data) {
        let tempList = [];
        try {
            await api.fetchLinkedOstData(data.data).then((response) => {
                tempList = response.data.map((x) => new EquipmentStepInfo(x));
            });
            // Set the duration of each following step; the final step has none.
            for (let i = 0; i < tempList.length; i++) {
                tempList[i].tijdsduurvolgende =
                    tempList[i + 1]?.tijdsduur ?? null;
            }
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_scaledata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async storeBatchOstSteps(context, data) {
        let tempList = [];
        try {
            await api.storeStepsForBatch(data.data).then((response) => {
                tempList = response.data.map((x) => new EquipmentStepInfo(x));
            });
            // Set the duration of each following step; the final step has none.
            for (let i = 0; i < tempList.length; i++) {
                tempList[i].tijdsduurvolgende =
                    tempList[i + 1]?.tijdsduur ?? null;
            }
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_ostdata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    async unLinkStepsOst(context, data) {
        try {
            await api.unLinkStepsOst(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data
                        .func('prod_steps', { ns: 'production' })
                        .toLowerCase()
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_bak', { ns: 'production' })
                }),
                error
            );
        }
    },
    async hasOstPLCdata(context, data) {
        let result = false;
        try {
            const item = await api.hasOstPLCdata(data.data);
            result = item.data;
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_steps', { ns: 'production' })
                }),
                error
            );
        }
        return result;
    },
    async loadOrderedAlternatives(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchOrderedAlternatives(data.data);
            tempList = res.data;
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('prod_bak', { ns: 'production' })
                        .toLowerCase()
                }),
                error
            );
        }
        return tempList;
    }
};

export default actions;
